











































































































import {
  defineComponent, ref, computed, onMounted, onBeforeUnmount, watch,
} from '@vue/composition-api';
import { Toast } from '@hb/coffee';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

import { getMoreCapital, calcWithOrder, applyWithMoreCapital } from '@/api/ordersV2';
import type { MoreCapitalResItem } from '@/api/ordersV2/types';
import type { RepayDialogDataType } from '@/components/finance-replan/types';
// 异步引入组件
const FinanceReplan = () => import('@/components/finance-replan/index.vue');
const ForceAgreementView = () => import('../force-agreement-view/index.vue');

export default defineComponent({
  name: 'UndertakeInvestors',
  components: {
    FinanceReplan,
    ForceAgreementView,
  },
  props: {
    loanOrderId: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const contractListRef = ref<HTMLDivElement | null>(null);
    /** 是否展示该组件 */
    const show = ref(false);
    /** 资方信息 */
    const contractList = ref<MoreCapitalResItem[]>([]);
    /** 当前选中的资方信息索引 */
    const currentIndex = ref(0);
    /** 当前选中的协议索引 */
    const currentContractIndex = ref(0);
    /** 倒计时 */
    const countDown = ref(5);
    /** 定时器 */
    let timer: number | null = null;
    /** 还款计划弹窗数据 */
    const repayDialogData = ref<RepayDialogDataType>();
    /** 是否展示还款计划弹窗 */
    const showReplan = ref(false);
    /** 是否展示强制阅读弹窗 */
    const showForceRead = ref(false);
    /** 资方编码 */
    const moreCapitalCode = ref('');

    /** 当前选中资方对应的合同信息 */
    const currentContractList = computed(() => contractList.value[currentIndex.value].contractList);

    /** 兜底资方名称处理 */
    const serialCapitalName = computed(() => contractList.value.map((it) => it.productName)
      .join(
        '、',
      ));

    /** 埋点参数 */
    const ubtParams = computed(() => ({
      capitalCode: moreCapitalCode.value,
    }));

    /** 切换资方索引 */
    const changeCurrentIndex = (index: number) => {
      currentIndex.value = index;
      currentContractIndex.value = 0;
      if (contractListRef.value) {
        contractListRef.value.scrollTo(0, 0);
      }
    };

    /** 切换协议索引 */
    const changeContractIndex = (index: number) => {
      currentContractIndex.value = index;
    };

    /** 显示还款计划弹窗 */
    const showFinanceReplan = async () => {
    // 还款计划点击埋点
      ubtSetupPageButton('finance_loan_applyResult_moreCapital_repaymentDialog', ubtParams.value);
      /** 没有还款计划数据，才请求 */
      if (!repayDialogData.value) {
        repayDialogData.value = await calcWithOrder({ loanOrderId: props.loanOrderId });
      }
      showReplan.value = true;
      // 还款计划曝光埋点
      ubtSetupModuleExpose('finance_loan_applyResult_moreCapital_repaymentDialog', ubtParams.value);
    };

    /** 获取兜底资方信息 */
    const getMoreCapitalInfo = async () => {
      const { contractResList, showPanel, moreCapitalCode: code } = await getMoreCapital(
        { loanOrderId: props.loanOrderId },
      );
      contractList.value = contractResList;
      show.value = showPanel;
      moreCapitalCode.value = code;
      // 结果页提现资方兜底模块曝光埋点
      if (showPanel) {
        ubtSetupModuleExpose('finance_loan_applyResult_moreCapital', ubtParams.value);
      }
    };
    getMoreCapitalInfo();

    onMounted(() => {
      timer = window.setInterval(() => {
        if (countDown.value > 0) {
          countDown.value -= 1;
        }
      }, 1000);
    });

    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    });

    // 点击唤起协议弹窗
    const handleContractClick = (index: number) => {
      currentContractIndex.value = index;
      showForceRead.value = true;
      // 协议弹窗曝光埋点
      ubtSetupModuleExpose('finance_loan_applyResult_moreCapital_agreementDialog', ubtParams.value);
    };

    /** 发起申请 */
    const applyLoanOrder = async () => {
      /** 发起申请 */
      const { result, msg } = await applyWithMoreCapital({ loanOrderId: props.loanOrderId });
      if (result) {
        Toast('申请已提交，请耐心等待');
      } else {
        Toast(msg);
      }
      show.value = false;
    };

    // 点击申请按钮
    const handleApplyLoanOrder = () => {
      if (countDown.value) return;
      // 申请按钮点击埋点
      ubtSetupPageButton('finance_loan_applyResult_moreCapital_apply', ubtParams.value);
      applyLoanOrder();
    };

    // 监听协议弹窗申请按钮点击
    const handleAgreementApplyClick = () => {
      if (countDown.value) return;
      // 兜底协议模块点击申请埋点
      ubtSetupPageButton('finance_loan_applyResult_moreCapital_agreementDialog_apply', ubtParams.value);
      applyLoanOrder();
    };

    return {
      contractListRef,
      show,
      contractList,
      currentIndex,
      currentContractList,
      countDown,
      serialCapitalName,
      repayDialogData,
      showReplan,
      showForceRead,
      currentContractIndex,
      changeCurrentIndex,
      showFinanceReplan,
      handleApplyLoanOrder,
      handleAgreementApplyClick,
      handleContractClick,
      changeContractIndex,
    };
  },
});
